// Channel Analytic Components - Refactored from ChannelAnalyticContent.jsx
// These components maintain EXACT same functionality as original

export { SectionHeader } from './SectionHeader';
export { HealthGrade } from './HealthGrade';
export { ScoreCard } from './ScoreCard';
export { TopPerformingPosts } from './TopPerformingPosts';
export { NotificationStatus } from './NotificationStatus';
export { BestPostingTime } from './BestPostingTime';
export { PostDetailModal } from './PostDetailModal';
export { GrowthAnalysis } from './GrowthAnalysis';
export { EngagementMetrics } from './EngagementMetrics';
export { ContentDistribution } from './ContentDistribution';
export { RecentPostsTable } from './RecentPostsTable';
export { SignalMetrics } from './SignalMetrics';
export { ViewsBySource } from './ViewsBySource';

// Constants
export const DATE_RANGES = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: '7d', label: 'Last 7 Days' },
  { value: '30d', label: 'Last 30 Days' },
  { value: 'this_month', label: 'This Month' },
  { value: 'last_month', label: 'Last Month' },
  { value: '90d', label: 'Last 3 Months' },
  { value: 'jan_2026', label: 'January 2026' },
  { value: 'feb_2026', label: 'February 2026' },
  { value: 'mar_2026', label: 'March 2026' },
  { value: 'all', label: 'All Time' },
];
